import { useEffect } from "react";

export default function ParticlesBackground() {
  useEffect(() => {
    // init
    if (window.particlesJS) {
      window.particlesJS.load(
        "particles-js",
        "/particles/particles-config.json",
        () => {}
      );
    }

    // cleanup: distrugge canvas e istanze
    return () => {
      if (window.pJSDom && window.pJSDom.length) {
        window.pJSDom.forEach((p) => p?.pJS?.fn?.vendors?.destroypJS?.());
        window.pJSDom = [];
      }
    };
  }, []);

  return (
    <div
      id="particles-js"
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 0
      }}
    />
  );
}